module.exports = __webpack_public_path__ + "src/img/newEmpty.8657c20f.png";